import type { TestSingleChoiceElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'
import React from 'react'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './TestSingleChoiceElement/TestSingleChoiceElement'
import type { TestSingleChoiceDemoType } from './testSingleChoiceTypes'

const DEMO_VALUE: TestSingleChoiceElementValue = {
  items: [
    {
      isValid: true,
      label: textToRtValue(t('elements.testSingleChoice.value.rightAnswer')),
      points: 1,
      value: 'radio_1',
    },
    {
      isValid: false,
      label: textToRtValue(t('elements.testSingleChoice.value.wrongAnswer')),
      points: 1,
      value: 'radio_2',
    },
    {
      isValid: false,
      label: textToRtValue(t('elements.testSingleChoice.value.wrongAnswer')),
      points: 1,
      value: 'radio_3',
    },
  ],
  isRandom: true,
}

const TestSingleChoiceDemo: TestSingleChoiceDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.testSingleChoice.type}-demo`,
        type: CONFIG_ELEMENTS.testSingleChoice.type,
        value: DEMO_VALUE,
        font: {},
        feedback: {},
        style: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default React.memo(TestSingleChoiceDemo) as typeof TestSingleChoiceDemo
